export const checksums = {
  "articles_en": "v3.5.0--tMht9TSl1jU8lEnqLbMnsixMwgQbsNp4wmZTv0lJf1A",
  "articles_lo": "v3.5.0--TnXrzl0MmIFmKAoxcnPLMFCNPVpm85O6xzUIgVSVPpc",
  "articles_ms": "v3.5.0--057L1spfueuv_Au7V_xEfcHOy9787cIeqPinX_OJjpg",
  "articles_th": "v3.5.0--7bzrRo_rFOIgR57WrAEwNeHmhZmidpbqNw6sUIji0gI",
  "articles_vi": "v3.5.0--YBQvk2RsS71GkIE7XNFIHzcI5_QvVsL9XBjyCwLsFRY",
  "articles_zh_hans": "v3.5.0--zMLbcAoFCpXp1nrrQ8ODaPMNLMqnoVilXcq21wPCUhQ",
  "articles_zh_hant": "v3.5.0--IzaY9NR0VgghSnu7CYYt4Cl2oDJK4jj3BNULf2xhdSs"
}
export const checksumsStructure = {
  "articles_en": "tMht9TSl1jU8lEnqLbMnsixMwgQbsNp4wmZTv0lJf1A",
  "articles_lo": "TnXrzl0MmIFmKAoxcnPLMFCNPVpm85O6xzUIgVSVPpc",
  "articles_ms": "057L1spfueuv_Au7V_xEfcHOy9787cIeqPinX_OJjpg",
  "articles_th": "7bzrRo_rFOIgR57WrAEwNeHmhZmidpbqNw6sUIji0gI",
  "articles_vi": "YBQvk2RsS71GkIE7XNFIHzcI5_QvVsL9XBjyCwLsFRY",
  "articles_zh_hans": "sm5_R1VxmC2JLHXRjobzyPCROvaqqR1oMWajohKq3mU",
  "articles_zh_hant": "IzaY9NR0VgghSnu7CYYt4Cl2oDJK4jj3BNULf2xhdSs"
}

export const tables = {
  "articles_en": "_content_articles_en",
  "articles_lo": "_content_articles_lo",
  "articles_ms": "_content_articles_ms",
  "articles_th": "_content_articles_th",
  "articles_vi": "_content_articles_vi",
  "articles_zh_hans": "_content_articles_zh_hans",
  "articles_zh_hant": "_content_articles_zh_hant",
  "info": "_content_info"
}

export default {
  "articles_en": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "bannerImg": "string",
      "body": "json",
      "created": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "articles_lo": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "bannerImg": "string",
      "body": "json",
      "created": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "articles_ms": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "bannerImg": "string",
      "body": "json",
      "created": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "articles_th": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "bannerImg": "string",
      "body": "json",
      "created": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "articles_vi": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "bannerImg": "string",
      "body": "json",
      "created": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "articles_zh_hans": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "bannerImg": "string",
      "body": "json",
      "created": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "articles_zh_hant": {
    "type": "page",
    "fields": {
      "id": "string",
      "title": "string",
      "authors": "json",
      "bannerImg": "string",
      "body": "json",
      "created": "string",
      "description": "string",
      "extension": "string",
      "meta": "json",
      "navigation": "json",
      "path": "string",
      "seo": "json",
      "stem": "string",
      "tags": "json"
    }
  },
  "info": {
    "type": "data",
    "fields": {}
  }
}